module.exports = __webpack_public_path__ + "img/p-mark.ecff437.png";